<template lang="pug">
  .activity-success
    .header
      img(src="../../../public/images/member/activity-success-header.png")
    .page-module.flow
      img(src="../../../public/images/member/activity-success-flow.png")
    .page-module.pay
      .title 支付方式
      .pay-item
        .pay-name
          img(src="../../../public/images/member/wx-pay.jpg")
          span 微信支付
        .pay-select
          input(type="radio", checked)
    .pay-bottom
      .tip 领不到话费，全额退款
      .price
        span.label 会员费：
        span.price-val ¥9.9
        del ¥29.8
      .submit-button
        el-button(@click="toPay") 确认支付
</template>

<script>
export default {
  data() {
    return {
      channel: 'TUIA',
      form: {
        mobile: '',
        verifyCode: '',
        goodsCode: 'WXPAPAY210226001'
      },
      openId: '',
      channelOrderNo: ''
    }
  },
  mounted() {
    this.form.mobile = this.$route.params.mobile
    this.form.verifyCode = this.$route.params.verifyCode
    this.channelOrderNo = this.$route.params.oid
    if ((!this.form.mobile || !this.form.verifyCode) && window.localStorage) {
      let _orderCache = JSON.parse(localStorage.getItem('language-member-order'));
      this.form.mobile = _orderCache.mobile
      this.form.verifyCode = _orderCache.verifyCode
      this.channelOrderNo = _orderCache.oid
    }
    let _reqNo = localStorage.getItem('language_memeber_signpay_req_no')
    if (_reqNo) {
      this.queryPapayContract(_reqNo)
    }
    this.code = this.getQueryParamByKey('code')
    if (this.code) {
      this.getOpenId()
    }
    // this.setWXConfig()
    if (window._czc) {
      window._czc.push(['_trackEvent', 'Language会员', '微信内H5确认订单露出', 'Language会员', 1, '成功'])
    }
  },
  methods: {
    getOpenId() {
      this.$service.UserService
        .getWxUserToken({
          code: this.code
        })
        .then(res => {
          if (res.data.success) {
            this.openId = res.data.sub_data.openId
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    getQueryParamByKey (paramName){
      let url = document.location.toString()
      // 如果url中有特殊字符则需要进行一下解码
      url = decodeURI(url)
      let arrObj = url.split("?");
      if (arrObj.length > 1) {
          let arrPara = arrObj[1].split("&");
          let arr;
          for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");
            if (arr != null && arr[0] == paramName) {
              return decodeURIComponent(arr[1]);
            }
          }
          return "";
      } else {
          return "";
      }
    },
    queryPapayContract(_reqNo) {
      this.$service.OrderService
        .queryPapayContractOrder({
          mobile: this.user.mobile,
          goodsCode: this.form.goodsCode,
          reqNo: _reqNo
        })
        .then(res => {
          if (!res.data.success || res.data.sub_data.trade_state !== 'SUCCESS') {
            this.$message({
              type: 'warning',
              message: '未签约成功'
            })
          } else {
            this.$message({
              type: 'success',
              message: '支付成功，正在前往Language会员公众号'
            })
            location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU0NjkwNjU1Mw==&scene=124#wechat_redirect'
          }
        })
    },
    toPay() {
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel,
        tradeType: 'MWEB',
        channelOrderNo: this.channelOrderNo
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在验证信息并前往签约...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (window._czc) {
        window._czc.push(['_trackEvent', 'Language会员', '微信内H5触发订单签约', 'Language会员', 1, '成功'])
      }
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            if (window._czc) {
              window._czc.push(['_trackEvent', 'Language会员', '微信内H5订单签约跳转', 'Language会员', 1, '成功'])
            }
            this.signDialogVisible = false
            localStorage.setItem('language_memeber_signpay_req_no', res.data.sub_data.req_no)
            location.href = res.data.sub_data.pay_url
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    setWXConfig() {
      this.$service.UserService
        .getJssdkSign({
          url: location.href.split('#')[0]
        })
        .then(res => {
          if (res.data.success) {
            window.wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.sub_data.app_id, // 必填，公众号的唯一标识
              timestamp: res.data.sub_data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.sub_data.nonce_str, // 必填，生成签名的随机串
              signature: res.data.sub_data.signature,// 必填，签名
              jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'chooseWXPay'
              ],
              openTagList: ['wx-open-launch-weapp']
            });
            window.wx.ready(function () {
              this.$message({
                type: 'success',
                message: 'Success'
              })
            });
            window.wx.error(function (res) {
              this.$message({
                type: 'error',
                message: JSON.stringify(res)
              })
            });
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.activity-success{
  background-color: #f3f3f3;
  padding-bottom: 5rem;
  img{
    width: 100%;
  }
}
.info{
  font-size: 1.1rem;
  text-align: center;
  padding-top: 3rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
.page-module{
  width: 92%;
  margin: 0 auto;
  border-radius: 4px;
}
.pay-bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  >div{
    flex: 1;
    height: 3.4rem;
    line-height: 3.4rem;
    &.price{
      font-size: 1rem;
      .label{
        margin-left: .5rem;
      }
      .price-val{
        font-size: 1.4rem;
        color: #f04346;
      }
      del{
        font-size: .8rem;
        color: #a3a3a3;
      }
    }
    &.submit-button{
      text-align: right;
      button{
        border: 0;
        background-color: #f04346;
        color: #fff;
        font-size: 1.2rem;
        width: 100%;
        height: 3.4rem;
        border-radius: 0;
      }
    }
  }
  .tip{
    background: linear-gradient(to bottom,#ff632a,#ff3143);
    color: #fff;
    font-size: .8rem;
    position: absolute;
    top: -1.6rem;
    left: 3rem;
    border-radius: .3rem;
    height: 1rem;
    line-height: 1rem;
    padding: .2rem .4rem;
    &:after{
      content: '';
      position: absolute;
      left: 1rem;
      bottom: 0;
      width: 0;
      height: 0;
      border: .3rem solid transparent;
      border-top: .6rem solid #ff3143;
      transform: translateY(100%) skew(-30deg);
    }
  }
}
.pay{
  background-color: #fff;
  padding: .3rem 0;
  .title{
    padding: .3rem .5rem;
    font-size: 1rem;
    color: #525252;
  }
  .pay-item{
    display: flex;
    padding: .3rem;
    >div{
      flex: 1;
    }
    .pay-name{
      font-size: 1rem;
      img{
        width: 1.3rem;
        height: 1.3rem;
        vertical-align: top;
        margin: 0 .3rem;
      }
    }
    .pay-select{
      text-align: right;
      input{
        margin-right: 1rem;
      }
    }
  }
}
</style>